import axios from 'axios'
import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'

import {
  SERVER_URL,
  DEFAULT_LANGUAGE,
  DEFAULT_TRANSLATED_WORDS,
} from './constants'
import { LanguageContext } from './contexts/LanguageContext'
import { TranslatedWordsContext } from './contexts/TranslatedWordsContext'
import { UserContext } from './contexts/UserContext'
import router from './router'

import './App.css'

function App() {
  const [user, setUser] = useState() // stores user

  const [language, setLanguage] = useState(
    localStorage.getItem('language')
      ? JSON.parse(localStorage.getItem('language'))
      : DEFAULT_LANGUAGE,
  ) // stores user language

  const [translatedWords, setTranslatedWords] = useState(
    localStorage.getItem('translatedWords')
      ? JSON.parse(localStorage.getItem('translatedWords'))
      : DEFAULT_TRANSLATED_WORDS,
  ) // stores translated words

  useEffect(() => {
    if (!localStorage.getItem('translatedWords')) {
      localStorage.setItem(
        'translatedWords',
        JSON.stringify(DEFAULT_TRANSLATED_WORDS),
      )
    }

    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', JSON.stringify(DEFAULT_LANGUAGE))
    }

    axios
      .get(`${SERVER_URL}/translated_words/${language?.code}`)
      .then((res) => {
        setTranslatedWords(res.data)
        localStorage.setItem('translatedWords', JSON.stringify(res.data))
      })
  }, [])

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <LanguageContext.Provider value={{ language, setLanguage }}>
        <TranslatedWordsContext.Provider
          value={{ translatedWords, setTranslatedWords }}
        >
          <RouterProvider router={router} />
        </TranslatedWordsContext.Provider>
      </LanguageContext.Provider>
    </UserContext.Provider>
  )
}

export default App
